import { Button, Empty } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { CloudSync } from "@/icons"

import styles from "./EmptyTable.module.scss"

import type { LoadErrorEmptyTableProps } from "./EmptyTable.types"

// A table whose request failed: says so instead of "no data", with a retry
export const LoadErrorEmptyTable = ({ onRetry }: LoadErrorEmptyTableProps) => {
  const { t } = useTranslation()

  return (
    <Empty
      image={<CloudSync className={styles.iconLoadError} />}
      description={t("general.loadError")}
    >
      {onRetry && (
        <Button type="link" onClick={onRetry}>
          {t("general.refresh")}
        </Button>
      )}
    </Empty>
  )
}
